var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#EDEDED"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "video-camera_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M4 4h24v24H4z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#video-camera_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.587 19.654h7.307v-.358c0-.868-.442-1.442-1.326-1.722-.884-.28-1.66-.42-2.328-.42-.668 0-1.444.14-2.327.42-.884.28-1.326.854-1.326 1.722v.358zm3.653-3.808c.486 0 .9-.17 1.24-.51.34-.34.51-.754.51-1.24s-.17-.899-.51-1.24c-.34-.34-.754-.51-1.24-.51s-.899.17-1.239.51c-.34.341-.51.754-.51 1.24s.17.9.51 1.24c.34.34.754.51 1.24.51zM8.548 23.5c-.505 0-.933-.175-1.283-.525a1.745 1.745 0 01-.525-1.283V10.308c0-.505.175-.933.525-1.283.35-.35.778-.525 1.283-.525h11.385c.505 0 .932.175 1.282.525.35.35.525.778.525 1.283v4.577l2.737-2.737a.43.43 0 01.499-.103c.189.075.284.22.284.434v7.042c0 .214-.095.359-.284.434a.43.43 0 01-.5-.103l-2.736-2.737v4.577c0 .505-.175.933-.525 1.283-.35.35-.777.525-1.282.525H8.548zm0-1.5h11.385a.3.3 0 00.22-.087.3.3 0 00.087-.22V10.307a.3.3 0 00-.086-.222.3.3 0 00-.221-.086H8.548a.3.3 0 00-.221.086.3.3 0 00-.087.222v11.384a.3.3 0 00.087.221.3.3 0 00.221.087z",
    fill: "#212121"
  }))));
}
export default __webpack_public_path__ + "assets/static/media/video-camera.a255928b.svg";
export { SvgVideoCamera as ReactComponent };